export default [
  {
    path: '/admin/trader/indicator-performance',
    name: 'IndicatorPerformance',
    component: () => import('@/views/Admin/Trader/IndicatorPerformance/Index.vue'),
    meta: {
      pageTitle: 'Performans',
      breadcrumb: [
        { text: 'Trader', active: false },
        { text: 'Performans', active: true },
      ],
      resource: 'indicators.list',
      action: 'read',
    },
  },
]
